import { Avatar, Button, Modal, Table, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import ConvertToShamsi from "../../../extentions/convertors/ConvertToShamsi";
import { GetViews, GetViewsId } from "../../../services/NoticeService";
import { useEffect, useState } from "react";
import {
  GetMyCompanyAccelerator,
  GetMyCompanyAcceleratorByBatchId,
  GetMyCompanyAcceleratorsReciver,
} from "../../../services/CompanyService";

const SentAccelerators = () => {
  const [getViewsModal, setViewsModal] = useState(false);
  const [getViewsData, setViewsData] = useState([]);
  const [getViewsIdData, setViewsIdData] = useState<any>([]);
  const [getAcceleratorData, setAcceleratorData] = useState();
  const [getAcceleratorReciverData, setAcceleratorReciverData] = useState();
  const [getDetails, setDetails] = useState();
  const [getDetailsDialog, setDetailsDialog] = useState(false);
  useEffect(() => {
    GetMyCompanyAccelerator().then((p) => setAcceleratorData(p.data.data));
    GetMyCompanyAcceleratorsReciver().then((p) =>
      setAcceleratorReciverData(p.data.data)
    );
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: "بازدید کنندگان",
      dataIndex: "companyId",
      key: "companyId",
      render: (item, record, index) => <>{item}</>,
    },
  ];

  const columnsDetails: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "2%",
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: " دریافت کننده",
      dataIndex: "name",
      key: "name",
      width: "20%",
      render: (item, record, index) => <>{record?.companyName}</>,
    },
    {
      title: "وضعیت",
      dataIndex: "name",
      key: "name",
      width: "20%",
      render: (item, record, index) => (
        <>
          {getViewsIdData.some(
            (data: any) => data.companyId === record?.reciverCompanyId
          ) ? (
            <>
              <Tag color="green">مشاهده شده</Tag>{" "}
            </>
          ) : (
            <Tag color="yellow">ارسال شده </Tag>
          )}
        </>
      ),
    },
    {
      title: "تاریخ مشاهده",
      dataIndex: "name",
      key: "name",
      width: "20%",
      render: (item, record, index) => (
        <>
          {getViewsIdData.some(
            (data: any) => data.companyId === record?.reciverCompany?.id
          ) ? (
            <>
              {ConvertToShamsi(
                getViewsIdData[
                  getViewsIdData.findIndex(
                    (data: any) => data.companyId === record?.reciverCompany?.id
                  )
                ].dateTime
              )}
            </>
          ) : (
            <></>
          )}
        </>
      ),
    },
  ];
  const columnsTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "2%",
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: " عنوان آگهی ",
      dataIndex: "title",
      key: "title",
      width: "15%",
    },
    {
      title: "نوع شتاب",
      dataIndex: "accelaratorType",
      key: "accelaratorType",
      width: "5%",
      render: (item, record, index) => (
        <>{record.accelaratorType === 0 ? "پیامک" : "اعلان درون سیستمی"} </>
      ),
    },
    {
      title: "تاریخ",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "5%",

      render: (item, record, index) => (
        <>{ConvertToShamsi(record.createdDate)}</>
      ),
    },
    {
      title: "مشاهده کرده ها",
      dataIndex: "noticeState",
      key: "noticeState",
      width: "5%",

      render: (item, record, index) => (
        <>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              GetViews(record.noticeId)
                .then((p) => {
                  setViewsData(p.data.data);
                })
                .then(() => setViewsModal(true));
            }}
          >
            <Avatar.Group>
              <Avatar style={{ backgroundColor: "#f56a00" }}>CN</Avatar>
              <Avatar style={{ backgroundColor: "#f56a00" }}>CN</Avatar>
              <Avatar style={{ backgroundColor: "#f56a00" }}>CN</Avatar>
            </Avatar.Group>
          </div>
        </>
      ),
    },
    {
      title: "",
      dataIndex: "noticeState",
      key: "noticeState",
      width: "5%",

      render: (item, record, index) => (
        <>
          <Button
            className=" "
            style={{ width: "6rem" }}
            type="default"
            onClick={() => {
              GetViewsId(record.noticeId).then((p) =>
                setViewsIdData(p.data.data)
              );
              GetMyCompanyAcceleratorByBatchId(record.id).then((p) => {
                //console.log(p.data.data[0].accelarators);

                //console.log(p.data.data[0].accelarators);

                setDetails(p.data.data[0].accelarators);
              });
              setDetailsDialog(true);
            }}
          >
            جزئیات شتاب
          </Button>
        </>
      ),
    },
  ];
  return (
    <>
      <div style={{ width: "1700px" }}>
        <Table
          style={{ margin: "auto", width: "1500px" }}
          columns={columnsTotal}
          className="mt-2"
          size="small"
          dataSource={getAcceleratorData}
          pagination={false}
        />
      </div>
      <Modal
        open={getDetailsDialog}
        footer={null}
        onCancel={() => setDetailsDialog(false)}
      >
        <div>
          <Table
            columns={columnsDetails}
            className="mt-2"
            size="small"
            dataSource={getDetails}
            pagination={false}
          />
        </div>
      </Modal>
      <Modal
        open={getViewsModal}
        footer={null}
        onCancel={() => setViewsModal(false)}
      >
        <Table dataSource={getViewsData} pagination={false} columns={columns} />
      </Modal>
    </>
  );
};

export default SentAccelerators;
